module.exports = __webpack_public_path__ + "static/media/Highgate Close N6 (14).f21543fc.JPG";